import _ from 'lodash'

/**
 * @var {ApiMiddleware}
 */
let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setResourceTypeApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        resourceTypes: [],
        resourceTypeFunctions: [],
    },
    getters: {
        resourceTypes: state => state.resourceTypes,
        resourceTypeById: state => id => _.find(state.resourceTypes, { id: id }),
    },
    mutations: {
        setResourceTypes: (state, resourceTypes) => {
            state.resourceTypes = resourceTypes
        },
        addResourceType: (state, newResourceType) => {
            state.resourceTypes.push(newResourceType)
        },
    },
    actions: {
        async resourceTypesLoad({ commit }) {
            return api.get('/resourceType?depth=2')
                .then(data => {
                    commit('setResourceTypes', data)
                    return data
                })
        },
        async updateResourceType(_, data) {
            console.info(data)
            return api.put(`/resourceType/${data.id}`, data)
        },
        async createResourceType(_, data) {
            console.info(data)
            return api.post('/resourceType', data)
        },
    },
})
